export default __webpack_public_path__ + "static/media/news-thumb1.2c772b42.png";